import { render, staticRenderFns } from "./TandC.vue?vue&type=template&id=893e88ea&"
import script from "./TandC.vue?vue&type=script&lang=js&"
export * from "./TandC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports